import { useDisclosure } from '@chakra-ui/react';
import React, { Dispatch, ReactNode, SetStateAction, useContext, useState } from 'react';

interface ModalProps {
  isOpen: boolean;
	onOpen: () => void;
  onClose: () => void;
}

interface CompaniesContextValue {
	companyId?: string | null,
	setCompanyId: Dispatch<SetStateAction<string | null | undefined>>,
	modals: {
    importMembers: ModalProps,
    createMember: ModalProps
  }
}

interface CompaniesProviderProps {
	companyId?: string | null;
	children?: ReactNode;
}

const CompaniesContext = React.createContext<CompaniesContextValue | undefined>(
	undefined,
);

export const useCompaniesContext = () => {
	const value = useContext(CompaniesContext);
	if (value === undefined) {
		throw Error('useCompaniesContext can not be used outside a CompaniesProvider');
	}
	return value;
};

export default function CompaniesProvider({ children, ...data }: CompaniesProviderProps) {
	const [companyId, setCompanyId] = useState<string | null | undefined>(data.companyId);
	const modalImportMembers = useDisclosure();
  const modalCreateMember = useDisclosure();

	return (
		<CompaniesContext.Provider
			value={{
				companyId,
				setCompanyId,
				modals: {
          importMembers: modalImportMembers,
          createMember: modalCreateMember
        }
			}}>
			{children}
		</CompaniesContext.Provider>
	);
}
